//Include Both Helper File with needed methods
import { getFirebaseBackend } from '../../../helpers/firebase_helper'
import {
  postFakeLogin,
  postJwtLogin
} from '../../../helpers/fakebackend_helper'

import {
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag
} from './reducer'
import { Axios } from 'api/axios'
import axios from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const loginUser = (user: any, history: any) => async (dispatch: any) => {
  try {
    const userPayload = { email: user?.email, password: user?.password };

    const response = await Axios.post('api/user/login/', JSON.stringify(userPayload), {
      headers: { 'Content-Type': 'application/json' },
    });

    // Backend returned 200
    if (response.status === 200 && response.data) {
      const userData = response.data;

      localStorage.setItem('authUser', JSON.stringify(userData));
      dispatch(loginSuccess(userData));
      const userId = userData.user?.user_id;
      if (userId) {
        dispatch(fetchLatestPermissionsLogin(userId));
      }
      return Promise.resolve(userData);
    } else {
      dispatch(apiError('Login failed. Please check your credentials.'));
      return Promise.reject('Login failed');
    }
  } catch (error: any) {
    console.error('Login error:', error);

    const resData = error?.response?.data;
    let backendMsg = 'Failed to login. Please try again later.';
    if (resData && typeof resData === 'object') {
      backendMsg = resData.message || resData.error || resData.detail || backendMsg;
    }

    dispatch(apiError(backendMsg));
    return Promise.reject(backendMsg);
  }
};


export const logoutUser = () => async (dispatch: any) => {
  try {
    localStorage.removeItem('authUser')
    if (process.env.REACT_APP_DEFAULTAUTH === 'firebase') {
      let fireBaseBackend = getFirebaseBackend()
      const response = fireBaseBackend.logout
      dispatch(logoutUserSuccess(response))
    } else {
      dispatch(logoutUserSuccess(true))
    }
  } catch (error) {
    dispatch(apiError(error))
  }
}

export const socialLogin =
  (type: any, history: any) => async (dispatch: any) => {
    try {
      let response

      if (process.env.REACT_APP_DEFAULTAUTH === 'firebase') {
        const fireBaseBackend = getFirebaseBackend()
        response = fireBaseBackend.socialLoginUser(type)
      }
      //  else {
      //   response = postSocialLogin(data);
      // }

      const socialdata = await response
      if (socialdata) {
        localStorage.setItem('authUser', JSON.stringify(socialdata))
        dispatch(loginSuccess(socialdata))
        history('/dashboard')
      }

    } catch (error) {
      dispatch(apiError(error))
    }
  }

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    const response = dispatch(reset_login_flag())
    return response
  } catch (error) {
    dispatch(apiError(error))
  }
}

export const fetchUserDetails = createAsyncThunk(
  'Login/fetchUserDetails',
  async (_, { getState }) => {
    const state: any = getState();
    const userId = state.Login.user?.user_id;
    if (!userId) throw new Error("User ID not found in state");
    const response = await Axios.get(`users/users/${userId}/`);
    return response.data;
  }
);

export const fetchLatestPermissions = createAsyncThunk(
  "Login/fetchLatestPermissions",
  async (_, { getState, rejectWithValue, dispatch }) => {
    try {
      const state: any = getState();
      const userId = state.Login.user?.user?.user_id
        || JSON.parse(localStorage.getItem('authUser') || '{}')?.user?.user_id;

      if (!userId) return rejectWithValue("User ID not found in state");

      const res = await Axios.get(`api/permissions/users/${userId}/`);

      // Check if user is inactive or deleted
      if (res.data?.detail === "User inactive or deleted") {
        // Logout the user immediately
        await dispatch(logoutUser());
        window.location.href = "/login";
        return rejectWithValue("User inactive or deleted");
      }
      const permissions = res.data?.permissions || [];
      const userType = res.data?.data?.user_type_name

      // Update localStorage and Redux in one step
      const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
      // console.log("authUser", authUser);

      authUser.user.user_type = userType;
      authUser.permissions = permissions;
      //*// Set the new userType(If changed)
      const updatedAuthUser = { ...authUser, user_type: userType, permissions };
      localStorage.setItem("authUser", JSON.stringify(updatedAuthUser));
      localStorage.setItem("userPermissions", JSON.stringify(permissions));

      dispatch(loginSuccess(updatedAuthUser));

      return permissions;
    } catch (error: any) {
      // Check if the error response indicates user is inactive or deleted
      if (error.response?.data?.detail === "User inactive or deleted" || error.response?.data?.detail === "Invalid token") {
        // Logout the user immediately
        await dispatch(logoutUser());
        window.location.href = "/login";
        return rejectWithValue("User inactive or deleted");
      }
      return rejectWithValue(error.response?.data || "Failed to fetch latest permissions");
    }
  }
);

export const fetchLatestPermissionsLogin = createAsyncThunk(
  "Login/fetchLatestPermissions",
  async (userId: string, { dispatch, rejectWithValue }) => {
    try {
      const res = await Axios.get(`api/permissions/users/${userId}/`);
      const permissions = res.data?.permissions || [];
      // console.log(permissions,"permissions---------22")

      // Store in localStorage
      localStorage.setItem('userPermissions', JSON.stringify(permissions));

      // Update Redux state with new permissions
      const authUser = JSON.parse(localStorage.getItem('authUser') || '{}');
      dispatch(loginSuccess({
        ...authUser,
        permissions
      }));

      return permissions;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Failed to fetch latest permissions");
    }
  }
);


